"use strict";
var distill;
(function (distill) {
    var dashboards;
    (function (dashboards) {
        const GLOBAL_FILTER_MIN_RESULTS_FOR_SEARCH = '10';
        class GlobalFiltersEditor extends distill.EditorBase {
            constructor() {
                super(...arguments);
                this._draft = [];
            }
            getValue() {
                return Object.freeze(this.getFilters());
            }
            getValueForEdit() {
                return appn.utils.deepClone(this.getFilters());
            }
            setValue(newValue) {
                dashboards.designer.updateGlobalFilters(newValue || []);
            }
            init() {
                this.$list = this.$editor.find('.global-filters-list');
                this.$addBtn = this.$editor.find('.add-global-filter');
                this.$limitHint = this.$editor.find('.global-filter-limit-hint');
            }
            update() {
                this._draft = this.getValueForEdit();
                this.renderRows();
            }
            bindEvents() {
                this.$addBtn.on('click', (e) => {
                    e.preventDefault();
                    this.addFilter();
                });
                this.$editor.on('click', '.remove-global-filter', (e) => {
                    e.preventDefault();
                    this._draft.splice($(e.currentTarget).closest('.globalFilterRow').index(), 1);
                    this.commit();
                });
                this.$editor.on('change input', '.global-filter-label', e => {
                    const index = this.rowIndex(e);
                    const isBlur = e.type === 'change';
                    if (isBlur && !($(e.target).val() || '').trim()) {
                        const defaultLabel = this.defaultFilterLabel(index);
                        $(e.target).val(defaultLabel);
                        this.updateFilter(index, { label: defaultLabel });
                        return;
                    }
                    this.updateFilter(index, { label: $(e.target).val() || '' });
                });
                this.$editor.on('focus', '.global-filter-label', e => {
                    const $input = $(e.target);
                    if ($input.val() === this.defaultFilterLabel(this.rowIndex(e)))
                        $input.val('');
                });
                this.$editor.on('change input', '.global-filter-data-name', e => {
                    const value = ($(e.target).val() || '').trim();
                    this.updateFilter(this.rowIndex(e), { dataName: value || null });
                });
                this.$editor.on('change', '.global-filter-type', e => {
                    const type = $(e.target).val();
                    const updates = { type };
                    if (type !== dashboards.DashboardGlobalFilterType.Dropdown) {
                        updates.sourceDatasetId = null;
                        updates.displayColumn = null;
                        updates.valueColumn = null;
                    }
                    this.updateFilter(this.rowIndex(e), updates);
                });
                this.$editor.on('change', '.global-filter-dataset', e => {
                    this.updateFilter(this.rowIndex(e), {
                        sourceDatasetId: $(e.target).val() || null,
                        displayColumn: null,
                        valueColumn: null
                    });
                });
                this.$editor.on('change', '.global-filter-display-column', e => {
                    const displayColumn = $(e.target).val() || null;
                    this.updateFilter(this.rowIndex(e), { displayColumn, valueColumn: displayColumn });
                });
                this.$editor.on('change', '.global-filter-value-column', e => {
                    this.updateFilter(this.rowIndex(e), { valueColumn: $(e.target).val() || null });
                });
            }
            rowIndex(e) {
                return $(e.currentTarget).closest('.globalFilterRow').index();
            }
            renderRows() {
                if (!this.$list || !this.$list.length)
                    return;
                const $existing = this.$list.children('.globalFilterRow');
                for (let i = $existing.length - 1; i >= this._draft.length; i--)
                    $($existing[i]).remove();
                for (let i = 0; i < this._draft.length; i++) {
                    const filter = this._draft[i];
                    const $row = i < $existing.length ? $($existing[i]) : null;
                    if ($row && $row.attr('data-filter-id') === filter.id)
                        this.syncRow($row, filter);
                    else if ($row)
                        $row.replaceWith(this.buildRow(filter));
                    else
                        this.$list.append(this.buildRow(filter));
                }
                const atLimit = this._draft.length >= dashboards.designer.maxGlobalFilters;
                this.$addBtn.toggleClass('d-none', atLimit || !this._canSave);
                this.$limitHint.toggleClass('d-none', !atLimit);
                this.initSelects();
                if (!this._canSave)
                    this.$editor.find('input, select, .remove-global-filter, .add-global-filter').prop('disabled', true);
            }
            syncRow($row, filter) {
                $row.find('.global-filter-label').val(filter.label || '');
                $row.find('.global-filter-data-name').val(filter.dataName || '');
                const type = filter.type || dashboards.DashboardGlobalFilterType.Text;
                const $type = $row.find('.global-filter-type');
                if ($type.val() !== type) {
                    $type.val(type);
                    $type.trigger('change.select2');
                }
                $row.find('.global-filter-dropdown-config').toggleClass('d-none', filter.type !== dashboards.DashboardGlobalFilterType.Dropdown);
                const datasetId = filter.sourceDatasetId || '';
                const $dataset = $row.find('.global-filter-dataset');
                if ($dataset.val() !== datasetId) {
                    this.populateDatasets($dataset, datasetId);
                    $dataset.trigger('change.select2');
                }
                const datasetIdForColumns = filter.sourceDatasetId || null;
                this.syncColumnSelect($row.find('.global-filter-display-column'), datasetIdForColumns, filter.displayColumn || '', T('Select display column...'));
                this.syncColumnSelect($row.find('.global-filter-value-column'), datasetIdForColumns, filter.valueColumn || '', T('Select value column...'));
            }
            syncColumnSelect($select, datasetId, selectedId, placeholderText) {
                this.populateColumns($select, datasetId, selectedId, placeholderText);
                $select.trigger('change.select2');
            }
            initSelects() {
                if (!this.$editor || !this.$editor.length || !this.$editor.is(':visible'))
                    return;
                appn.select.initForDesign({
                    elements: this.$editor.find('.global-filter-dataset').not('.select2-hidden-accessible'),
                    minimumResultsForSearch: GLOBAL_FILTER_MIN_RESULTS_FOR_SEARCH,
                    isIconTextSelect: true,
                    isHierarchical: true
                });
                appn.select.initForDesign({
                    elements: this.$editor.find('.global-filter-type, .global-filter-display-column, .global-filter-value-column').not('.select2-hidden-accessible'),
                    omitWidth: true,
                    minimumResultsForSearch: GLOBAL_FILTER_MIN_RESULTS_FOR_SEARCH
                });
            }
            addFilter() {
                if (!this._canSave || this._draft.length >= dashboards.designer.maxGlobalFilters)
                    return;
                const number = this.nextFilterNumber();
                this._draft.push({
                    id: appn.utils.newGuid(true),
                    label: this.defaultFilterLabel(number - 1),
                    type: dashboards.DashboardGlobalFilterType.Text,
                    sourceDatasetId: null,
                    displayColumn: null,
                    valueColumn: null
                });
                this.commit();
            }
            nextFilterNumber() {
                let number = this._draft.length + 1;
                while (this._draft.some(filter => { var _a; return ((_a = filter.label) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === this.defaultFilterLabel(number - 1).toLowerCase(); }))
                    number++;
                return number;
            }
            defaultFilterLabel(index) {
                return T('Filter {0}', (index + 1).toString());
            }
            updateFilter(index, updates) {
                if (!this._draft[index])
                    return;
                this._draft[index] = Object.assign(Object.assign({}, this._draft[index]), updates);
                this.commit();
            }
            commit() {
                this.setValue(this._draft);
            }
            buildRow(filter) {
                const $row = appn.utils.cloneTemplate('globalFilterRowTemplate');
                $row.attr('data-filter-id', filter.id);
                $row.find('.global-filter-label').val(filter.label || '');
                $row.find('.global-filter-data-name').val(filter.dataName || '');
                $row.find('.global-filter-type').val(filter.type || dashboards.DashboardGlobalFilterType.Text);
                const $dropdownConfig = $row.find('.global-filter-dropdown-config');
                $dropdownConfig.toggleClass('d-none', filter.type !== dashboards.DashboardGlobalFilterType.Dropdown);
                this.populateDatasets($row.find('.global-filter-dataset'), filter.sourceDatasetId || '');
                this.populateColumns($row.find('.global-filter-display-column'), filter.sourceDatasetId || null, filter.displayColumn || '', T('Select display column...'));
                this.populateColumns($row.find('.global-filter-value-column'), filter.sourceDatasetId || null, filter.valueColumn || '', T('Select value column...'));
                return $row;
            }
            populateDatasets($select, selectedId) {
                $select.empty();
                $select.append($('<option>').val('').text(T('Choose dataset...')));
                (dashboards.designer.getDatasets() || []).forEach(dataset => {
                    const $option = $('<option>').val(dataset.id);
                    dashboards.buildDatasetOption($option, dataset);
                    $select.append($option);
                });
                $select.val(selectedId || '');
            }
            populateColumns($select, datasetId, selectedId, placeholderText) {
                $select.empty();
                $select.append($('<option>').val('').text(placeholderText));
                if (datasetId) {
                    const dataset = (dashboards.designer.getDatasets() || []).find(d => d.id === datasetId);
                    if (dataset)
                        (dataset.columns || []).forEach(column => $select.append($('<option>').val(column.id).text(dashboards.getColumnOptionText(column))));
                }
                $select.val(selectedId || '');
            }
            getFilters() {
                const design = dashboards.designer._design;
                return (design && design.globalFilters) ? design.globalFilters : [];
            }
        }
        dashboards.GlobalFiltersEditor = GlobalFiltersEditor;
        distill.editors.register('globalFiltersEditor', GlobalFiltersEditor);
    })(dashboards = distill.dashboards || (distill.dashboards = {}));
})(distill || (distill = {}));
